import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { QuestionService } from 'app/question/services/question.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { QuestionAnswerModel } from 'app/question/models/question-answer.model';

@Component({
    selector: 'app-add-question-answer',
    templateUrl: './add-question-answer.component.html',
    styleUrls: ['./add-question-answer.component.css']
})
export class AddQuestionAnswerComponent implements OnInit {
    public title = ClassicEditor;
    errors: string[];
    questionAnswers: QuestionAnswerModel[];
    addQuestionAnswerFormGroup: FormGroup;
    currentQuestionAnswers: QuestionAnswerModel[] = [];
    @Output() getQuestionAnswers: EventEmitter<QuestionAnswerModel[]> = new EventEmitter<QuestionAnswerModel[]>();
    @Input() questionId: string;
    @Input() isEditMode: boolean;

    constructor(
        private questionService: QuestionService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        //this.getQuestionAnswersData();
        this.initializeForm();
        if (this.questionId) {
            this.getCurrentQuestionAnswers();
        }
    }

    getCurrentQuestionAnswers(): void {
        this.questionService.getCurrentQuestionAnswers(this.questionId).subscribe(result => {
            this.currentQuestionAnswers = result;
        });
    }

    // using datalist in input not list of all submitted answers
    //getQuestionAnswersData(): void {
    //    this.questionService.getQuestionAnswers().subscribe(result => {
    //        this.questionAnswers = result;
    //    });
    //}

    initializeForm(): void {
        this.addQuestionAnswerFormGroup = this.fb.group(
            {
                title: ['', Validators.required],
                score: ['', Validators.required],
                comment: ['']
            }
        );
    }

    onQuestionAnswerChange($event: string): void {
        let questionAnswer = this.questionAnswers.find(q => q.id == $event);
        this.addQuestionAnswerFormGroup.get('title').setValue(questionAnswer.title);
        this.addQuestionAnswerFormGroup.get('score').setValue(questionAnswer.score);
        this.addQuestionAnswerFormGroup.get('comment').setValue(questionAnswer.comment);
    }

    updateQuestionAnswers(): void {
        this.getQuestionAnswers.emit(this.currentQuestionAnswers);
    }

    addQuestionAnswer(): void {
        let newITem = new QuestionAnswerModel();
        newITem.score = this.addQuestionAnswerFormGroup.value.score;
        newITem.title = this.addQuestionAnswerFormGroup.value.title;
        newITem.comment = this.addQuestionAnswerFormGroup.value.comment;
        this.currentQuestionAnswers.push(newITem);

        this.getQuestionAnswers.emit(this.currentQuestionAnswers);
    }

    deleteQuestionAnswer(index: number): void {
        this.currentQuestionAnswers.splice(index, 1);
        this.getQuestionAnswers.emit(this.currentQuestionAnswers);
    }
}
